import { withStyle, styled } from 'baseui';
import { StyledBodyCell, StyledHeadCell, StyledTable } from 'baseui/table-grid';
import { Icon } from './Icon';
import { cx } from 'class-variance-authority';

export const Table = withStyle(StyledTable, {
  borderTopColor: '',
  borderBottomColor: '',
  borderLeftColor: '',
  borderRightColor: '',
  borderTopStyle: 'none',
  borderBottomStyle: 'none',
  borderLeftStyle: 'none',
  borderRightStyle: 'none',
  color: '#C1CAD6',

  backgroundColor: 'transparent',
  borderBottomLeftRadius: 'none',
  borderBottomRightRadius: 'none',
  borderTopLeftRadius: 'none',
  borderTopRightRadius: 'none',
  rowGap: '8px',
});

export const HeadRow = styled('div', {
  display: 'contents',
});

export const Row = styled('div', {
  display: 'contents',
});

export const HeadCell = withStyle(StyledHeadCell, {
  fontFamily: 'Montserrat',
  fontWeight: 'normal',
  borderTopColor: '',
  borderBottomColor: '',
  borderLeftColor: '',
  borderRightColor: '',
  borderTopStyle: 'none',
  borderBottomStyle: 'none',
  borderLeftStyle: 'none',
  borderRightStyle: 'none',

  fontSize: '0.75rem',
  color: '#B5B5B5',

  backgroundColor: 'transparent',
  borderBottomLeftRadius: 'none',
  borderBottomRightRadius: 'none',
  borderTopLeftRadius: 'none',
  borderTopRightRadius: 'none',

  paddingLeft: '0.75rem',
  paddingRight: '0.75rem',
});

interface SortingHeadCellProps {
  sortDirection: 'asc' | 'desc' | 'default';
  onSort: (newDirection: 'asc' | 'desc' | 'default') => void;
  children: React.ReactNode;
}

export const SortingHeadCell = (props: SortingHeadCellProps) => {
  const { sortDirection, onSort, children } = props;

  const iconClasses = cx({
    'rotate-180': sortDirection === 'desc',
    'rotate-0': sortDirection === 'asc',
    hidden: sortDirection === 'default',
  });

  return (
    <HeadCell onClick={onSort}>
      <div className='flex cursor-pointer flex-row items-center gap-1'>
        <Icon
          icon='arrow_upward'
          className={iconClasses}
          color={sortDirection === 'default' ? '#B5B5B5' : '#F0F0F0'}
        />
        {children}
      </div>
    </HeadCell>
  );
};

export const Cell = withStyle(
  StyledBodyCell,
  (props: {
    rounded?: string;
    borderStyle?: 'solid' | 'none';
    noSideBorders?: boolean;
  }) => {
    const noSideBorders = props.noSideBorders ?? false;
    return {
      display: 'flex',
      fontWeight: 'normal',
      alignItems: 'center',
      backgroundColor: '#121315',
      borderColor: '#48484E',
      borderTopStyle: props.borderStyle || 'solid',
      borderBottomStyle: props.borderStyle || 'solid',
      borderLeftStyle: noSideBorders ? 'none' : 'hidden',
      borderRightStyle: noSideBorders ? 'none' : 'hidden',
      borderWidth: '0.2px',
      paddingLeft: noSideBorders ? '0px' : '0.75rem',
      paddingRight: '0.75rem',
      paddingTop: noSideBorders ? '4px' : '12px',
      paddingBottom: '12px',
      ':first-child': {
        borderTopLeftRadius: props.rounded || '8px',
        borderBottomLeftRadius: props.rounded || '8px',
        borderLeftStyle: noSideBorders ? 'none' : props.borderStyle || 'solid',
        paddingLeft: noSideBorders ? '0px' : '1.5rem',
      },
      ':last-child': {
        borderTopRightRadius: props.rounded || '8px',
        borderBottomRightRadius: props.rounded || '8px',
        borderRightStyle: noSideBorders ? 'none' : props.borderStyle || 'solid',
        paddingRight: noSideBorders ? '0px' : '1.5rem',
      },
    };
  }
);
